import { chain, reduce } from "lodash"

const queryStringReducers = chain(require.context(".", true, /^\.\/[^/]+\/model.js/).keys())
  .map(path => path.split("/")[1])
  .reduce((reducersMap, id) => {
    const reducers = require(`./${id}/model`).queryStringReducers
    if (reducers) {
      return reduce(reducers, (reducersMap, reducer, actionType) => {
        if (!reducersMap[actionType]) {
          reducersMap[actionType] = [reducer]
        } else {
          reducersMap[actionType].push(reducer)
        }
        return reducersMap
      }, reducersMap)
    }
    return reducersMap
  }, {})
  .value()

export default queryStringReducers
